var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9719 18.999C11.9657 18.9988 11.9595 18.9984 11.9533 18.998C11.9144 18.9958 11.8763 18.991 11.8391 18.9834L11.8195 18.9795C11.8152 18.9785 11.8111 18.9766 11.8068 18.9756C11.7654 18.9653 11.7253 18.952 11.6867 18.9355C11.6811 18.9332 11.6757 18.9303 11.6701 18.9277C11.6288 18.909 11.5891 18.8875 11.552 18.8623C11.5107 18.8343 11.4713 18.8022 11.4348 18.7656L5.23457 12.5654L5.17988 12.5049C4.92372 12.1907 4.94183 11.7274 5.23457 11.4346C5.52743 11.1417 5.99067 11.1237 6.30488 11.3799L6.36641 11.4346L11.2004 16.2686L11.2004 5.7998C11.2006 5.35817 11.5585 5.00003 12.0002 5C12.4419 5 12.7998 5.35816 12.8 5.7998L12.8 16.2705L17.635 11.4346C17.9474 11.1223 18.4534 11.1223 18.7658 11.4346C19.078 11.747 19.0781 12.2531 18.7658 12.5654L12.5656 18.7656L12.5051 18.8203C12.4958 18.8279 12.4853 18.8337 12.4758 18.8408C12.3726 18.9175 12.2514 18.9715 12.1184 18.9912C12.1118 18.9922 12.1054 18.9933 12.0988 18.9941C12.0665 18.9981 12.0336 19 12.0002 19C11.9907 19 11.9813 18.9994 11.9719 18.999Z",
    fill: "#607238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.4e9ed76eb44fd19b970d36209eb4f01d.svg";
export { ForwardRef as ReactComponent };